function openTabFeed(evt, sectionId, tabName) {
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
    tablinks[i].setAttribute("aria-selected", "false");
    tablinks[i].setAttribute("tabindex", "-1");
  }

  const panel = document.getElementById("tabpanel-" + tabName);
  if (panel) panel.style.display = "block";

  const current = evt.currentTarget;
  current.classList.add("active");
  current.setAttribute("aria-selected", "true");
  current.setAttribute("tabindex", "0");
}

function initTabKeyboard(tablist) {
  if (tablist._tabKeyboardInit) return;
  tablist._tabKeyboardInit = true;

  tablist.addEventListener("keydown", function (e) {
    const tabs = Array.from(tablist.querySelectorAll("[role='tab']"));
    const currentIndex = tabs.indexOf(document.activeElement);
    if (currentIndex === -1) return;

    let newIndex = currentIndex;

    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      newIndex = (currentIndex + 1) % tabs.length;
      e.preventDefault();
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      e.preventDefault();
    } else if (e.key === "Home") {
      newIndex = 0;
      e.preventDefault();
    } else if (e.key === "End") {
      newIndex = tabs.length - 1;
      e.preventDefault();
    } else {
      return;
    }

    tabs[newIndex].focus();
    tabs[newIndex].click();
  });
}

function initAllTablists() {
  document.querySelectorAll("[role='tablist']").forEach(initTabKeyboard);
  document.querySelectorAll("[role='tab']").forEach(function (tab) {
    if (tab.getAttribute("aria-selected") !== "true") {
      tab.setAttribute("tabindex", "-1");
    }
  });
}

initAllTablists();

document.querySelectorAll("[data-default-open]").forEach(function (el) {
  el.click();
});

window.addEventListener("shopify:section:load", function () {
  document.querySelectorAll("[data-default-open]").forEach(function (el) {
    el.click();
  });
  initAllTablists();
});
